import AddRulePopup from "@/features/list/components/AddRulePopup";
import { CloneGroupPopup } from "@/features/list/components/CloneGroupPopup";
import DeleteGroupPopup from "@/features/list/components/DeleteGroupPopup";
import { Modal } from "@mui/material";

interface GroupModalsProps {
  isAddRulePopupOpen: boolean;
  isDeleteGroupPopupOpen: boolean;
  isCloneGroupPopupOpen: boolean;
  workflow_id: string | undefined;
  selectedWorkflowId: string;
  selectedWorkflowLabel: string;
}
export const GroupModals = ({
  isAddRulePopupOpen,
  isDeleteGroupPopupOpen,
  isCloneGroupPopupOpen,
  workflow_id,
  selectedWorkflowId,
  selectedWorkflowLabel,
}: GroupModalsProps) => {
  return (
    <>
      <Modal
        open={isAddRulePopupOpen}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        sx={{
          minWidth: "600px",
        }}
      >
        <AddRulePopup />
      </Modal>

      <Modal
        open={isDeleteGroupPopupOpen}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        sx={{
          minWidth: "600px",
        }}
      >
        <DeleteGroupPopup
          my_workflow_id={workflow_id}
          selected_workflow_id={selectedWorkflowId}
          selected_workflow_label={selectedWorkflowLabel}
        />
      </Modal>

      <Modal
        open={isCloneGroupPopupOpen}
        sx={{
          minWidth: "600px",
        }}
      >
        <CloneGroupPopup
          workflow_id={selectedWorkflowId}
          workflow_label={selectedWorkflowLabel}
        />
      </Modal>
    </>
  );
};
